import { LuArrowRight } from "react-icons/lu";
import { SwitchStateLink } from "@/pages/quiz/base/questions/sumsubAttachmentBlock/switchStateLink";
import { VerifyButton } from "@/pages/quiz/base/questions/sumsubAttachmentBlock/states/components/verifyButton";
import { SsnDigitsInput } from "@/pages/quiz/base/questions/sumsubAttachmentBlock/states/components/ssnDigitsInput";
import {
  IdentityChip,
  IntroNote,
  ErrorBanner,
  EncryptedNote,
} from "@/pages/quiz/base/questions/sumsubAttachmentBlock/states/components/verifyChrome";

const SSN_LAST_4_LENGTH = 4;

interface IProps {
  value: string;
  isLoading: boolean;
  verifyError?: string;
  onChange: (value: string) => void;
  onSubmit: (ssnLastFour: string) => void;
  onUploadInstead: () => void;
  onScrollToTop: () => void;
}

const SsnLast4State = ({
  value,
  isLoading,
  verifyError,
  onChange,
  onSubmit,
  onUploadInstead,
  onScrollToTop,
}: IProps) => {
  const isValid = value.length === SSN_LAST_4_LENGTH;

  const handleContinue = () => {
    if (!isValid) return;
    // Bring the header/error into view (mobile fix).
    onScrollToTop();
    onSubmit(value);
  };

  return (
    <>
      <IdentityChip />

      <h1 className="mb-3 text-[28px] font-semibold leading-tight text-[#2c2150] sm:text-3xl">
        Verify it’s you to finish your order
      </h1>

      {/* <p className="mb-6 text-[15px] leading-relaxed text-[#303030]">
        Enter the last 4 digits of your Social Security number. We’ll match it
        against the name and date of birth on your account to confirm your
        identity.
      </p> */}

      <IntroNote />

      {verifyError && <ErrorBanner message={verifyError} />}

      <SsnDigitsInput value={value} onChange={onChange} error={!!verifyError} />

      <EncryptedNote />

      <VerifyButton
        label="Continue"
        loadingLabel="Verifying…"
        iconRight={<LuArrowRight size={20} />}
        disabled={!isValid}
        isLoading={isLoading}
        onClick={handleContinue}
      />

      <SwitchStateLink
        label="Verify with a photo ID and selfie instead"
        onClick={onUploadInstead}
        disabled={isLoading}
      />
    </>
  );
};

export { SsnLast4State };
